var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProactiveAudit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 22.5L5.00313 17.5269C5.00313 17.3611 5.06897 17.2021 5.18618 17.0849C5.30339 16.9677 5.46236 16.9019 5.62813 16.9019H11.8794C12.4556 16.9019 12.4525 16.3906 12.4525 15.1744C12.4525 13.9581 9.38875 12.9338 9.38875 8.65812C9.38875 4.3825 12.5625 3.125 15.2 3.125C17.8375 3.125 20.7106 4.3825 20.7106 8.65812C20.7106 12.9338 17.6631 13.6137 17.6631 15.1744C17.6631 16.735 17.6631 16.9019 18.1506 16.9019H24.3756C24.5414 16.9019 24.7004 16.9677 24.8176 17.0849C24.9348 17.2021 25.0006 17.3611 25.0006 17.5269V22.5H5Z",
    fill: "#161616",
    stroke: "#161616",
    strokeWidth: 2.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 26.25H25",
    stroke: "#161616",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProactiveAudit);
export default __webpack_public_path__ + "static/media/proactiveAudit.96f57a0742bdf4e2591e57df20f11249.svg";
export { ForwardRef as ReactComponent };